<template>
  <span class="poll_card" @click="() => this.selection(this.title)">
    <i :class="this.icon" class="poll_card-icon" />
    <h3 :class="{'poll_card-title' : text, 'poll_card-select' : text === undefined }" >
      {{ this.title }}
    </h3>
    <p class="poll_card-text">
      {{ this.text }}
    </p>
  </span>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String
    },
    selection: {
      type: Function
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.poll {
  &_card {
    margin: 5px;
    border: 1px solid #DCDCDC;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 1rem;
    max-width: 250px;
    min-width: 150px;
    cursor: pointer;
    &:hover {
      color: $primary;
      border-color: $primary;
    }
    &-icon {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 2rem 1rem;
    }
    &-title {
      font-weight: bold;
      font-size: 2em;
    }
    &-select {
      text-align: center;
      font-size: .8em;
      font-weight: bold;
      margin-top: -1rem;
      padding-bottom: 1rem;
    }
    &-text{
      font-size: .75em;
    }
  }
}
</style>
